import { isSSR } from './utils';

export const MAXIMUM_LENGTH = 999999;

export const NONE = '__none__';

export const FIVE_SECONDS_IN_MS = 5_000;
export const TEN_SECONDS_IN_MS = FIVE_SECONDS_IN_MS * 2;
export const FIFTEEN_SECONDS_IN_MS = FIVE_SECONDS_IN_MS * 3;
export const ONE_MINUTE_IN_MS = TEN_SECONDS_IN_MS * 6;
export const ONE_HOUR_IN_MS = ONE_MINUTE_IN_MS * 60;
export const ONE_DAY_IN_MS = ONE_HOUR_IN_MS * 24;
export const ONE_WEEK_IN_MS = ONE_DAY_IN_MS * 7;

export const USER_AGENTS = [
	'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/122.0.0.0 Safari/537.36',
	'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/17.2 Safari/605.1.15',
	'Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/121.0.6167.140 Safari/537.36',
];

export const IS_MAC =
	!isSSR && navigator.platform.toUpperCase().includes('MAC');
